import { glassSurface as e } from "../../theme/theme.mjs";
import { Icons as t } from "../Icons/Icons.mjs";
import { IconButton as n } from "../Button/IconButton.mjs";
import { Drawer as r } from "../Drawer/Drawer.mjs";
import { useTableContext as i } from "./TableProvider.mjs";
import "../../theme/mobileChrome.mjs";
import { useState as a } from "react";
import { css as o, styled as s } from "styled-components";
import { useTranslation as c } from "@maat/store-i18n";
import { Fragment as l, jsx as u, jsxs as d } from "react/jsx-runtime";
//#region src/components/Table/TableToolbar.tsx
var f = s.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${({ theme: e }) => e.spacing(1.5, 4)};

    /* Sticky scroll behavior */
    position: sticky;
    top: 0;
    z-index: 50;

    /* Frosted glass chrome — same surface as Modal/Drawer/FormLayout bars */
    ${e};
    transition: background ${({ theme: e }) => e.transitions.fast};

    /* Tint the frosted bar with primary while rows are selected */
    ${({ theme: e, $isSelectionMode: t }) => t && o`
            background:
                linear-gradient(0deg, ${e.colors.primary}14, ${e.colors.primary}14),
                ${e.glass.pillBackgroundStrong};
        `}

    /* Fully-rounded floating bar — spacing from the Table below is owned by
       the page's <VStack gap={3}> wrapper, not a margin here. */
    border-radius: ${({ theme: e }) => e.radii.lg};

    /* Sticks just under the opaque phone bar, not tucked beneath it. */
    @media (max-width: 1023px) {
        top: calc(${60}px + env(safe-area-inset-top, 0px));
    }
`, p = s.div`
    display: flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(1.5)};
    flex: 1;
    min-width: 0;
`, m = s.div`
    display: flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(1)};
    flex-shrink: 0;
`, h = s.span`
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.medium};
    color: ${({ theme: e }) => e.colors.primary};
    white-space: nowrap;
`, g = ({ searchSlot: e, actions: o, bulkActions: s, drawerContent: g, drawerTitle: _, className: v }) => {
	let { t: y } = c("ds"), { selectedRows: b } = i(), [x, S] = a(!1), C = _ ?? y("ds:table.filters"), w = b.length, T = w > 0;
	return /* @__PURE__ */ d(l, { children: [/* @__PURE__ */ d(f, {
		className: v,
		$isSelectionMode: T,
		children: [/* @__PURE__ */ u(p, { children: T ? /* @__PURE__ */ d(l, { children: [/* @__PURE__ */ u(h, { children: y("ds:table.selectedCount", { count: w }) }), s?.(b)] }) : /* @__PURE__ */ d(l, { children: [e, o] }) }), !T && g && /* @__PURE__ */ u(m, { children: /* @__PURE__ */ u(n, {
			icon: /* @__PURE__ */ u(t.SlidersHorizontal, { size: 16 }),
			tooltip: C,
			size: "sm",
			variant: "ghost",
			onClick: () => S(!0)
		}) })]
	}), g && /* @__PURE__ */ u(r, {
		open: x,
		onOpenChange: S,
		title: C,
		side: "right",
		width: "380px",
		children: g
	})] });
};
//#endregion
export { g as TableToolbar };
